<template>
  <div class="small text-muted">
    {{ t('needHelp.poradit') }}
    <br class="d-md-none">
    {{ t('needHelp.ozveteSe') }} <br class="d-none d-md-inline" v-if="profile.czTypography">
    {{ t('needHelp.pres') }} <a class="text-secondary" href="/#jakeContactForm" @click.prevent="scrollToContactForm">
    {{ t('needHelp.formular') }} </a> {{ t('needHelp.nebo') }} <a class="text-secondary" href="tel:420226224724">{{ t('needHelp.zavolejte') }}</a>.
  </div>
</template>

<script>
import {store} from "../store.js";
import {useI18n} from "vue-i18n";
import {useLocaleProfile} from "@/composables/useLocaleProfile";
import {ref} from 'vue'

export default {
  name: "NeedHelp",
  data() {
    return {
      store
    }
  },
  setup() {
    const {t,locale} = useI18n({useScope: 'global'})
    const {profile} = useLocaleProfile()
    const select = ref(0)
    const lang = locale;
    return {t, select, lang, profile}
  },
  methods: {
    scrollToContactForm() {
      const el = document.getElementById('jakeContactForm');
      if (el) {
        window.scrollTo({
          top: el.getBoundingClientRect().top + window.scrollY - 110,
          behavior: 'smooth'
        });
      }
    }
  }
}
</script>

<style scoped>

</style>